<template>
    <v-dialog width="600px" v-model="isOpenPermissionsView">
        <v-card elevation="0">
            <v-card-title primary-title>
                <v-row>
                    <v-col cols="12" align="start">
                        <div
                            v-if="$vuetify.breakpoint.mdAndDown"
                            class="primary--text text-overline text-center"
                        >
                            {{ type == 'CREATE' ? 'Creando' : 'Editando' }}
                            Credenciales
                        </div>
                        <div
                            v-else
                            class="
                                font-weight-light
                                primary--text
                                text-h5 text-capitalize
                                mt-n1
                            "
                        >
                            <v-icon large> mdi-key-variant </v-icon>
                            {{ type == 'CREATE' ? 'Creando' : 'Editando' }}
                            Credenciales
                        </div>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-row dense>
                    <v-col cols="12" md="12" class="px-1">
                        <v-card elevation="0">
                            <!-- <v-row class="my-1 mx-1">
                                <h4
                                    class="font-weight-light primary--text px-2"
                                >
                                    Nombre
                                </h4>
                            </v-row>
                            <v-divider class="mx-1"></v-divider> -->
                            <v-row no-gutters>
                                <v-text-field
                                    class="mx-4"
                                    v-model="form.name"
                                    prepend-icon="mdi-form-textbox"
                                    label="nombre"
                                ></v-text-field>
                            </v-row>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="12" class="px-1">
                        <v-card elevation="0">
                            <!-- <v-row class="my-1 mx-1">
                                <h4
                                    class="font-weight-light primary--text px-2"
                                >
                                    Content Type
                                </h4>
                            </v-row>
                            <v-divider class="mx-1"></v-divider> -->
                            <v-row no-gutters>
                                <v-text-field
                                    class="mx-4"
                                    v-model="form.content_type"
                                    prepend-icon="mdi-table"
                                    label="DB Table"
                                ></v-text-field>
                            </v-row>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="12" class="px-1">
                        <v-card elevation="0">
                            <!-- <v-row class="my-1 mx-1">
                                <h4
                                    class="font-weight-light primary--text px-2"
                                >
                                    Codename
                                </h4>
                            </v-row>
                            <v-divider class="mx-1"></v-divider> -->
                            <v-row no-gutters>
                                <v-text-field
                                    class="mx-4"
                                    v-model="form.codename"
                                    prepend-icon="mdi-barcode-scan"
                                    label="Codename"
                                ></v-text-field>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions class="justify-end pt-3">
                <v-btn
                    :disabled="!checkSubmitDisabled"
                    color="success"
                    @click="
                        submit();
                        close();
                    "
                >
                    {{ type == 'CREATE' ? 'Crear' : 'Editar' }}
                </v-btn>
                <v-btn text color="red" @click="close()"> Cerrar </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import defaultPermissionsForm from "@/util/DatabaseManagement/Auth/defaultPermissionsForm.js"
import { clone } from '@/util/libUtil.js';

export default {
    name: 'PermissionsForm',
    data: () => ({
    }),
    methods: {
        close() {
            this.form = clone(defaultPermissionsForm);
            this.isOpenPermissionsView = false;
        },
        submit() {            
            if(this.type == 'CREATE')
                this.createPermissions();
            else
                this.updatePermissions();
        },
        ...mapActions('databaseManagement/auth', ['createPermissions', 'updatePermissions']),
    },
    computed: {
        checkSubmitDisabled() {
            return (
                Boolean(this.form.name) &&
                Boolean(this.form.content_type) &&
                Boolean(this.form.codename)
            );
        },
        opciones() {
            return JSON.parse(localStorage.getItem('opciones'));
        },
        form: {
            get() {
                return this.$store.state.databaseManagement.auth.permissions.form;
            },
            set(value) {
                this.$store.commit('databaseManagement/auth/permissionsForm', value);
            },
        },
        isOpenPermissionsView: {
            get() {
                let isOpen =
                    this.$store.state.databaseManagement.auth.permissions.isOpenPermissionsView;
                if (!isOpen) this.form = clone(defaultPermissionsForm);

                return isOpen;
            },
            set(value) {
                this.$store.commit('databaseManagement/auth/isOpenPermissionsView', value);
            },
        },
        ...mapState('databaseManagement/auth', {
            type: (state) => state.permissions.type,
        }),
        ...mapState('util', {
            exportingProgress: (state) => state.exportingProgress,
            isExporting: (state) => state.isExporting,
        }),
    },
};
</script>

<style scoped>
.wrapper {
    width: 28px;
    margin-left: 30px;
}

.checkmark {
    stroke: green;
    stroke-dashoffset: 745.74853515625;
    stroke-dasharray: 745.74853515625;
    animation: dash 2s ease-out forwards;
}

@keyframes dash {
    0% {
        -dashoffset: 745.74853515625;
    }
    100% {
        stroke-dashoffset: 0;
    }
}
</style>